import { z } from 'zod';

import { DynamicArtifactTemplate } from '@eluve/llm-outputs';

import { AppointmentModel } from '../../models/appointment';
import { PatientType } from '../../models/patient';
import {
  CanSyncToEhrArgs,
  GetEhrDataOptions,
  VendorDataMapper,
  VendorSyncConfig,
} from '../vendor-data-mapper';

import { convertExperityDataToAppointmentModel } from './experity.appointment';
import { logo } from './logo';
import { appointmentSchema } from './types';

const appointmentData = z.object({
  appointments: z.array(z.unknown()),
});

export class ExperityVendorDataMapper implements VendorDataMapper {
  getChart = (data: unknown) => {
    throw new Error('Method not implemented.');
  };

  convertChartToSummary = ({
    data,
    template,
  }: {
    data: unknown;
    template: DynamicArtifactTemplate;
  }) => {
    return null;
  };

  getAppointments = (
    data: unknown,
    options: GetEhrDataOptions = {},
  ): AppointmentModel[] => {
    const appointments: AppointmentModel[] = [];
    const rawAppointments = appointmentData.parse(data);

    for (const appointment of rawAppointments.appointments) {
      const appointmentParseResult = appointmentSchema.safeParse(appointment);
      if (!appointmentParseResult.success) {
        throw new Error(
          `Invalid appointment data from 3rd party EHR: ${appointmentParseResult.error}`,
        );
      }

      const appointmentModel = convertExperityDataToAppointmentModel(
        appointmentParseResult.data,
        options,
      );
      appointments.push(appointmentModel);
    }

    return appointments;
  };

  getPatient = (): PatientType => {
    throw new Error('Method not implemented.');
  };

  getPatientEhrUrl = () => {
    return `https://pvpm.practicevelocity.com/24_2/LogDetail.aspx`;
  };

  getLogo = () => logo;

  getHomeUrl = (domain: string) => {
    return `https://${domain}`;
  };

  getSyncConfig(): VendorSyncConfig {
    return {
      isImportEnabled: true,
      isSyncEnabled: true,
      canSignNoteInEhr: false,
      shouldDisplayConfirmationBeforeSync: true,
      canSyncNoteToEhr: (data: CanSyncToEhrArgs) => {
        const externalPatientId = Boolean(data.externalPatientId);
        const eluveExtExists = Boolean(data.eluveExtExists);
        if (!externalPatientId) {
          return {
            canSync: false,
            reason: 'Selected patient was not imported from EHR',
          };
        }
        if (!eluveExtExists) {
          return {
            canSync: false,
            reason: 'Extension is not installed',
          };
        }
        return {
          canSync: true,
        };
      },
      canSyncWithManualChartUrl: false,
    };
  }
}
